<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                A2P Registration
            </h2>
        </template>

        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8 shadow sm:rounded-md bg-white">
                One moment while we redirect to Stripe...
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import JetButton from "./../../Jetstream/Button";
import JetFormSection from "./../../Jetstream/FormSection";
import JetInput from "./../../Jetstream/Input";
import JetInputError from "./../../Jetstream/InputError";
import JetLabel from "./../../Jetstream/Label";
import JetActionMessage from "./../../Jetstream/ActionMessage";
import JetSecondaryButton from "./../../Jetstream/SecondaryButton";

import exampleSelectable from "../../components/A2p/ExampleSelectable";



export default {
    name: 'A2P-Review',
    props: [],
    components: {
        AppLayout,
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        
        exampleSelectable,
    },
    data() {
        return {
            
        }
    },
    computed: {
        goodToContinue() {
            return true;
        },
    },
    mounted() {
       axios
            .post(route("a2p.stripeCheckout"), {

            })
            .then((response) => {
                 window.Stripe(response.data.stripeKey).redirectToCheckout({
                    sessionId: response.data.sessionId
                });
            })
            .catch(function (error) {
                console.log(error);
            });
    },
    methods: {
        saveProgress() {
            
        },
    },
    watch: {
    }

};
</script>

<style lang="scss" scoped>

.required {
    @apply text-red-500 font-bold text-xl pl-1;
}

.label {
    @apply font-bold text-gray-700;
}

.value {
    @apply font-light text-gray-600;
}

</style>
